import { type } from '../actions/type';


const INITIAL_STATE = ''


const switchHomeSectionReducer = (state = INITIAL_STATE, action) => {

    switch (action.type) {

        case type.SWITCH_HOME_SECTION:

            return action.payload.selectedMenu

        default:
            return state;
    }
}
export default switchHomeSectionReducer;